import { AppointmentMultiple } from 'model/NewMultipleBooking';
import { Waitlist, WaitlistCounts, WaitlistKey, WaitlistsPagination } from 'model/Waitlist';
import { Action } from 'redux';

export const WAITLISTS_RESET_ACTION_TYPE = 'waitlists/reset';

type WaitlistsResetAction = Action<typeof WAITLISTS_RESET_ACTION_TYPE>;

export const WAITLISTS_ERROR_ACTION_TYPE = 'waitlists/error';

type WaitlistsErrorAction = Action<typeof WAITLISTS_ERROR_ACTION_TYPE>;

export const WAITLISTS_OPEN_PANEL_ACTION_TYPE = 'waitlists/open_panel';

interface WaitlistsOpenPanelAction extends Action<typeof WAITLISTS_OPEN_PANEL_ACTION_TYPE> {
    payload: {
        key: WaitlistKey;
        marketplaceIds: Array<number>;
        waitlistId?: number;
    };
}

export const WAITLISTS_CLOSE_PANEL_ACTION_TYPE = 'waitlists/close_panel';

type WaitlistsClosePanelAction = Action<typeof WAITLISTS_CLOSE_PANEL_ACTION_TYPE>;

export const WAITLISTS_SELECT_ACTION_TYPE = 'waitlists/select';

interface WaitlistsSelectAction extends Action<typeof WAITLISTS_SELECT_ACTION_TYPE> {
    payload: {
        waitlistId?: number;
    };
}

export const WAITLISTS_SHOW_FORM_ACTION_TYPE = 'waitlists/show_form';

interface WaitlistsShowFormAction extends Action<typeof WAITLISTS_SHOW_FORM_ACTION_TYPE> {
    payload: {
        waitlistId?: number;
    };
}

export const WAITLISTS_HIDE_FORM_ACTION_TYPE = 'waitlists/hide_form';

type WaitlistsHideFormAction = Action<typeof WAITLISTS_HIDE_FORM_ACTION_TYPE>;

export const WAITLISTS_SAVE_SUCCESS_ACTION_TYPE = 'waitlists/save_success';

interface WaitlistsSaveSuccessAction extends Action<typeof WAITLISTS_SAVE_SUCCESS_ACTION_TYPE> {
    payload: {
        waitlist: Waitlist;
    };
}

export const WAITLISTS_START_CONVERSION_ACTION_TYPE = 'waitlists/start_conversion';

interface WaitlistsStartConversionAction extends Action<typeof WAITLISTS_START_CONVERSION_ACTION_TYPE> {
    payload: {
        waitlist: Waitlist;
        appointments: Array<AppointmentMultiple>;
    };
}

export const WAITLISTS_END_CONVERSION_ACTION_TYPE = 'waitlists/end_conversion';

interface WaitlistsEndConversionAction extends Action<typeof WAITLISTS_END_CONVERSION_ACTION_TYPE> {
    payload: {
        booked: boolean;
    };
}

export const WAITLISTS_REFRESH_LIST_ACTION_TYPE = 'waitlists/refresh_list';

type WaitlistsRefreshListAction = Action<typeof WAITLISTS_REFRESH_LIST_ACTION_TYPE>;

export const WAITLISTS_FETCH_START_ACTION_TYPE = 'waitlists/fetch_start';

type WaitlistsFetchStartAction = Action<typeof WAITLISTS_FETCH_START_ACTION_TYPE>;

export const WAITLISTS_FETCH_SUCCESS_ACTION_TYPE = 'waitlists/fetch_success';

interface WaitlistsFetchSuccessAction extends Action<typeof WAITLISTS_FETCH_SUCCESS_ACTION_TYPE> {
    payload: {
        waitlists: Array<Waitlist>;
        pagination: WaitlistsPagination;
        append: boolean;
    };
}

export const WAITLISTS_COUNTS_FETCH_SUCCESS_ACTION_TYPE = 'waitlists/counts_fetch_success';

interface WaitlistsCountsFetchSuccessAction extends Action<typeof WAITLISTS_COUNTS_FETCH_SUCCESS_ACTION_TYPE> {
    payload: {
        counts: WaitlistCounts;
    };
}

export const WAITLISTS_GET_START_ACTION_TYPE = 'waitlists/get_start';

type WaitlistsGetStartAction = Action<typeof WAITLISTS_GET_START_ACTION_TYPE>;

export const WAITLISTS_GET_SUCCESS_ACTION_TYPE = 'waitlists/get_success';

interface WaitlistsGetSuccessAction extends Action<typeof WAITLISTS_GET_SUCCESS_ACTION_TYPE> {
    payload: {
        waitlist: Waitlist;
    };
}

export const WAITLISTS_DELETE_START_ACTION_TYPE = 'waitlists/delete_start';

type WaitlistsDeleteStartAction = Action<typeof WAITLISTS_DELETE_START_ACTION_TYPE>;

export const WAITLISTS_DELETE_SUCCESS_ACTION_TYPE = 'waitlists/delete_success';

interface WaitlistsDeleteSuccessAction extends Action<typeof WAITLISTS_DELETE_SUCCESS_ACTION_TYPE> {
    payload: {
        waitlistId: number;
    };
}

export type WaitlistsAction =
    | WaitlistsResetAction
    | WaitlistsErrorAction
    | WaitlistsOpenPanelAction
    | WaitlistsClosePanelAction
    | WaitlistsSelectAction
    | WaitlistsShowFormAction
    | WaitlistsHideFormAction
    | WaitlistsSaveSuccessAction
    | WaitlistsStartConversionAction
    | WaitlistsEndConversionAction
    | WaitlistsRefreshListAction
    | WaitlistsFetchStartAction
    | WaitlistsFetchSuccessAction
    | WaitlistsCountsFetchSuccessAction
    | WaitlistsGetStartAction
    | WaitlistsGetSuccessAction
    | WaitlistsDeleteStartAction
    | WaitlistsDeleteSuccessAction;
